import React from 'react';
import { Helmet } from 'react-helmet';
import CouriersWidget from './widgets/couriers/CouriersWidget';
import OrdersTodayWidget from './widgets/orders/OrdersTodayWidget/OrdersTodayWidget';
import { OrderOverviewWidget } from './widgets/orders/OrderOverviewWidget';
import FutureOrdersWidget from './widgets/orders/FutureOrdersWidget';
import LinksWidget from './widgets/links/LinksWidget';
import GoToWidget from './widgets/orders/GoToWidget';
import DeviationWidget from './widgets/orders/DeviationWidget';
import CourierDeviationWidget from './widgets/orders/CourierDeviationWidget';
import DelayedDeviationWidget from './widgets/orders/DelayedDeviationWidget';

import './Dashboard.scss';

import { Region } from '../../types/orderTypes';
import DeviationsWidget2 from './widgets/orders/DeviationsWidget2';
import EtaWidget from './widgets/orders/EtaWidget';

export default function Dashboard({
  region,
  limitedAccess,
}: {
  region: Region;
  limitedAccess?: boolean;
}): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      {limitedAccess ? (
        <div className="dashboard">
          <div className="dashboard__item">
            <GoToWidget />
          </div>
        </div>
      ) : (
        <>
          <div className="dashboard">
            <div className="dashboard__item">
              <OrdersTodayWidget />
            </div>
            <div className="dashboard__item">
              <FutureOrdersWidget />
            </div>
            <div className="dashboard__item">
              <CouriersWidget region={region} />
            </div>
            <div className="dashboard__item__orders__view">
              <OrderOverviewWidget />
            </div>
            <div className="dashboard__item__stacked">
              <GoToWidget />
              <LinksWidget />
            </div>
          </div>
          <div className="dashboard__wide__item">
            <EtaWidget />
          </div>
          <div className="dashboard__wide__item">
            <DeviationWidget />
          </div>
          <div className="dashboard__wide__item">
            <CourierDeviationWidget />
          </div>
          <div className="dashboard__wide__item">
            <DelayedDeviationWidget />
          </div>
          <div className="dashboard__wide__item">
            <DeviationsWidget2
              title={'Orders with open courier deviations'}
              authorRoles={'courier'}
            />
          </div>
          <div className="dashboard__wide__item">
            <DeviationsWidget2
              title={'Orders with admin / sender deviations'}
              authorRoles={'admin,sender,sender_admin'}
            />
          </div>
        </>
      )}
    </>
  );
}
